<template>
    <div v-if="log">
        <top-navbar :breadcrumb="$route.params.groupId != 0 ? groupBreadcrumb : cohortBreadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col-11">
                    <simulation :registration="registration" :simulation="simulation"></simulation>
                    <log-content
                        :log="log"
                        :registration="registration"
                        :simulation="simulation"
                        :types="types"
                        :competencies="competencies"
                        :grid-competencies="gridCompetencies"
                        :lang="registration.degree.lang"
                        :filters="filters"
                        @filtersChanged="filters = $event"
                    ></log-content>
                </div>
                <div class="col-1">
                    <features
                        :log="log"
                        :registration="registration"
                        :simulation="simulation"
                        :lang="registration.degree.lang"
                        :competencies="competencies"
                        :grid-competencies="gridCompetencies"
                        :types="types"
                        :filters="filters"
                        @filtersChanged="filters = $event"
                    ></features>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Simulation from './log/Simulation'
    import LogContent from './log/LogContent'
    import Features from './log/GlobalFeatures'

    export default {

        components: {
            Simulation, LogContent, Features
        },

        data() {
            return {
                log: null,
                registration: null,
                simulation: null,
                types: null,
                competencies: null,
                gridCompetencies: null,
                filters: {
                    selectedTypes: [],
                    showCompetencies: false,
                    position1: true,
                    position2: true,
                },
            }
        },

        computed: {

            groupBreadcrumb() {
                const simRoute = this.$permissions.hasRight('dashboard.sessions.read')
                    ? '/astral/ui/dashboard/registrations/' + this.$route.params.registrationId + '/simulations/' + this.$route.params.simulationId + '/groups/' + this.$route.params.groupId
                    : null

                return [
                    {
                        name: this.registration.cohort.name,
                        route: '/astral/ui/dashboard/cohorts/' + this.registration.cohort_id
                    },
                    {
                        name: this.registration.degree.name,
                        route: '/astral/ui/dashboard/registrations/' + this.$route.params.registrationId + '/groups/' + this.$route.params.groupId
                    },
                    {
                        name: this.simulation.name,
                        route: simRoute
                    },
                    {
                        name: this.$t('common.log'),
                    }
                ]
            },

            cohortBreadcrumb() {
                const simRoute = this.$permissions.hasRight('dashboard.sessions.read')
                    ? '/astral/ui/dashboard/registrations/' + this.$route.params.registrationId + '/simulations/' + this.$route.params.simulationId + '/cohorts/' + this.registration.cohort_id
                    : null

                return [
                    {
                        name: this.registration.cohort.name,
                        route: '/astral/ui/dashboard/cohorts/' + this.registration.cohort_id
                    },
                    {
                        name: this.registration.degree.name,
                        route: '/astral/ui/dashboard/registrations/' + this.$route.params.registrationId + '/cohorts/' + this.registration.cohort_id
                    },
                    {
                        name: this.simulation.name,
                        route: simRoute
                    },
                    {
                        name: this.$t('common.log'),
                    }
                ]
            }
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$loader.show()
            axios.get('/astral/api/front/dashboard/registrations/'+to.params.registrationId+'/simulations/'+to.params.simulationId+'/log')
            .then(resp => {
                next(vm => {
                    vm.log = resp.data.data
                    vm.registration = resp.data.included.registration
                    vm.simulation = resp.data.included.simulation
                    vm.types = resp.data.included.types
                    vm.competencies = resp.data.included.competencies
                    vm.gridCompetencies = resp.data.included.grid_competencies
                    vm.$navigation.setLastSimulation(vm.registration, vm.simulation)
                    vm.$permissions.setRights(resp.data.included.rights)
                    vm.$loader.hide()
                })
            })
            .catch(err => {
                if (err.response.status == 403) {
                    Vue.prototype.$loader.hide()
                    next({ name: 'unauthorized' });
                }
            });
        }
    }
</script>
